// import util from './util'
import Vue from 'vue'
import { Toast } from 'vant';
Vue.use(Toast);

// 配置API接口地址
// var root = 'https://testpubapi.51autoshop.com/report/api/v1'
//正式
 var root = 'https://pubapi.51autoshop.com/report/api/v1'
// 引用axios
var axios = require('axios')
axios.defaults.timeout =  180000;
axios.defaults.withCredentials = true;
// 自定义判断元素类型JS
function toType (obj) {
 return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase()
}
// 参数过滤函数
function filterNull (o) {
 for (var key in o) {
   if (o[key] === null) {
     delete o[key]
   }
   if (toType(o[key]) === 'string') {
     o[key] = o[key].trim()
   } else if (toType(o[key]) === 'object') {
     o[key] = filterNull(o[key])
   } else if (toType(o[key]) === 'array') {
     o[key] = filterNull(o[key])
   }
 }
 return o
}
/**
 * 
 * @param {string} name 获取url参数 
 */
function GetQueryPara (name) {

  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  var r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return unescape(r[2]);
  }
  return null;

}

/*
 接口处理函数
 这个函数每个项目都是不一样的，我现在调整的是适用于
 https://cnodejs.org/api/v1 的接口，如果是其他接口
 需要根据接口的参数进行调整。参考说明文档地址：
 https://cnodejs.org/topic/5378720ed6e2d16149fa16bd
 主要是，不同的接口的成功标识和失败提示是不一致的。
 另外，不同的项目的处理方法也是不一致的，这里出错就是简单的alert
*/

function apiAxios(method, url, params, success, failure) {

  var token = GetQueryPara("token");
  console.warn("token:", token)
 if (params) {
   params = filterNull(params)
 }
 // util.showLoad()
 axios({
   method: method,
   url: url,
   data: method === 'POST' || method === 'PUT' ? params : null,
   params: method === 'GET' || method === 'DELETE' ? params : null,
   baseURL: root,
   withCredentials: false,
   headers: {
     "Authorization": "IAuth " + (token || "")
	  }
 })
 .then(function (res) {
	console.warn("res:",res)
	console.warn("postUrl",url);
	console.warn("postparams",params);
   console.warn("返回值", res.data.Success);
   if (res.data.Success === true) {
     // util.hideLoad()
	 // console.log("请求成功")
     if (success) {
       success(res.data.Result)
     }else{
	
	 }
   } else {
     // util.hideLoad()
     if (failure) {
       failure(res.data)
       Toast(res.data.message || '网络异常')
     } else {
       Toast(res.data.message || '网络异常')
       window.alert('error: ' + JSON.stringify(res.data))
     }
   }
 })
   .catch(function (err) {
     console.warn("error:", err)
     if (failure) {
       failure()
     }
   // util.hideLoad()
   let res = err.response
   if (err) {
//      window.alert('api error, HTTP CODE: ' + res.status)
   }
 })
}

// 返回在vue模板中的调用接口
export default {
 get: function (url, params, success, failure) {
   return apiAxios('GET', url, params, success, failure)
 },
 post: function (url, params, success, failure) {
   return apiAxios('POST', url, params, success, failure)
 },
 put: function (url, params, success, failure) {
   return apiAxios('PUT', url, params, success, failure)
 },
 delete: function (url, params, success, failure) {
   return apiAxios('DELETE', url, params, success, failure)
 },
 IsAdmin:function(){
    var admin = GetQueryPara("isadmin") || 0;
    return admin == 1;
 }

}





//////////////////
// WEBPACK FOOTER
// ./static/js/index.js
// module id = null
// module chunks = 